import React, {
    useEffect,
    useState
} from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Map as IMap } from 'immutable';
import { getCapiSessionID } from 'capi/redux/immutable';
import { injectIntl, intlShape } from 'react-intl';
import { payerAuthenticationCheckEnrollmentSerializer } from '../payment/capiOrderV4ItemSerializer';

import { usePayerAuthentication, POLLING_RESET } from './PayerAuthenticationProvider';
import { INTERRUPT_ROUTE_3DS_STEP_UP } from '../routing/InterruptRoutes';
import paymentMessages from '../payment/paymentMessages';

const POPOUT_WIN_WIDTH = 400;
const POPOUT_WIN_HEIGHT = 470;
export const STEP_UP_TIMEOUT_SECONDS = 600;


export const StepUp = ({
    paymentValues,
    capiSessionID,
    intl
}) => {
    const {
        enrollmentAccessToken,
        stepUpUrl,
        requestStepUpResults,
        pollingStatus,
        exitPayerAuthenticationFlow,
        showStepUpOverlay,
        setShowStepUpOverlay
    } = usePayerAuthentication();

    const merchantData = capiSessionID;

    const [timeOutTotal, setTimeOutTotal] = useState(0);
    const [stepUpWindow, setStepUpWindow] = useState(null);

    const checkStepUpStatus = () => {
        const stepUpStatusData = payerAuthenticationCheckEnrollmentSerializer(paymentValues.merge({
            requestNum: capiSessionID
        }));
        requestStepUpResults(stepUpStatusData);
    };

    const closeStepUpWindow = () => {
        if (stepUpWindow) {
            stepUpWindow.close();
            setStepUpWindow(null);
        }
        exitPayerAuthenticationFlow();
    };

    useEffect(() => {
        
        
        const interval = 1.2;

        
        
        if (!pollingStatus || pollingStatus === POLLING_RESET) { return; }

        if (pollingStatus === 'IN_PROGRESS') {
            
            if (timeOutTotal <= STEP_UP_TIMEOUT_SECONDS) {
                setTimeOutTotal(timeOutTotal + interval);

                setTimeout(checkStepUpStatus, interval * 1000);
            } else {
                
                
                closeStepUpWindow();
            }
        } else {
            
            
            closeStepUpWindow();
        }
    }, [pollingStatus]);

    useEffect(() => {
        if (!showStepUpOverlay && timeOutTotal > 10) {
            setShowStepUpOverlay(true);
        }
    }, [timeOutTotal]);

    const showAlert = () => {
        
        
        
        const alertHeader = intl.formatMessage(paymentMessages.stepUpPopOutBlockedHeader);
        const alertBody = intl.formatMessage(paymentMessages.stepUpPopOutBlocked);
        
        alert(`${alertHeader}\n\n${alertBody}`);
    };

    useEffect(() => {
        
        if (!stepUpWindow) {
            
            
            
            
            const features = `width=${POPOUT_WIN_WIDTH}, height=${POPOUT_WIN_HEIGHT}, left=${Math.floor(window.innerWidth / 2 - POPOUT_WIN_WIDTH / 2)}, top=${Math.floor(window.innerHeight / 2 - POPOUT_WIN_HEIGHT / 2)}`;
            const popOutUrl = `/store${INTERRUPT_ROUTE_3DS_STEP_UP}?stepUpUrl=${stepUpUrl}&merchantData=${merchantData}&enrollmentAccessToken=${enrollmentAccessToken}`;
            

            const popOutWindow = window.open(popOutUrl, '3DS Step Up Authentication', features);
            if (!popOutWindow) {
                showAlert();
            }
            setStepUpWindow(popOutWindow);
            
            setTimeout(() => {
                checkStepUpStatus();
            }, 3000);
        }
    }, []);

    useEffect(() => {
        if (stepUpWindow) {
            const timer = setInterval(() => {
                if (stepUpWindow.closed) {
                    
                    
                    exitPayerAuthenticationFlow();
                    clearInterval(timer);
                }
            }, 1000);
        }
    }, [stepUpWindow]);

    return <div id="stepUpIframeLauncher" />;
};

StepUp.defaultProps = {
};

StepUp.propTypes = {
    capiSessionID: PropTypes.string.isRequired,
    paymentValues: PropTypes.instanceOf(IMap).isRequired,
    intl: intlShape.isRequired
};

export const mapStateToProps = state => ({
    capiSessionID: getCapiSessionID(state)
});

export default connect(mapStateToProps)(injectIntl(StepUp));
